// Logged-in app page: clip-pack review grid (routes/PackQa.tsx). Keep keys in sync with
// pl/appPackQa.ts.
export const appPackQa = {
  crumb: {
    packs: 'Clips',
    review: 'Review',
  },
  tile: {
    aria: 'Clip {n}, {dur}',
  },
  badge: {
    unscreened: 'not checked',
  },
  blink: {
    label: 'Blink',
  },
  filter: {
    label: 'Verdict filter',
    all: 'All',
    quarantined: 'To decide',
    clean: 'Clean',
    duplicate: 'Duplicates',
    unscreened: 'Not checked',
  },
  item: {
    clip: 'clip',
    lightbox: 'Zoom clip {n}',
    noFrames: 'no frames',
    duplicateOf: 'duplicate · {index}',
    restore: 'Keep',
    reject: 'Reject',
  },
  reason: {
    credibleText: 'text in frame',
    cornerOverlay: 'corner overlay',
    phashDuplicate: 'duplicate',
    notChecked: 'not checked',
    unknown: 'checking',
    restoredByUser: 'kept by you',
  },
  lightbox: {
    position: 'clip {n} of {total}',
    first: 'first frame',
    last: 'last frame',
    firstShort: 'First',
    lastShort: 'Last',
    frameLabel: 'Which frame',
    prev: 'Previous clip',
    next: 'Next clip',
    close: 'Close',
  },
  bulk: {
    restore: 'Keep {n}',
    reject: 'Reject {n}',
    delete: 'Delete {n}',
  },
  progress: {
    cutting: 'Cutting files… {done} of {total}',
    notCut: 'not cut',
    unnamedFile: 'file',
  },
  toast: {
    restored: 'Kept clip {n}.',
    restoredMany_one: 'Kept {n} clip.',
    restoredMany_few: 'Kept {n} clips.',
    restoredMany_many: 'Kept {n} clips.',
    restoredMany: 'Kept {n} clips.',
    rejected: 'Rejected clip {n}.',
    rejectedMany_one: 'Rejected {n} clip.',
    rejectedMany_few: 'Rejected {n} clips.',
    rejectedMany_many: 'Rejected {n} clips.',
    rejectedMany: 'Rejected {n} clips.',
    restoreFailed: 'Could not keep clip {n}.',
    rejectFailed: 'Could not reject clip {n}.',
    undo: 'Undo',
  },
  empty: {
    title: 'Nothing to review',
    back: 'Back to the pack',
    refunded: 'This is one continuous clip',
  },
  error: {
    title: 'Could not load the clips.',
  },
}
